export default function () {
  const widgetName = "tier3BackgroundManaged";
  const widgetOpts = tier3BackgroundManagedOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    hasImages: true,
    buyNowButton: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    moreButton: false,
    textOverImage: false,
    link: [""],

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomBackground(widgetData);
      }
    },
  });

  function createCustomBackground(widgetData) {
    const { ImageWithPath } = widgetData[0];

    $(".second-tier-container").css(
      "background-image",
      `url('${ImageWithPath}')`
    );

    $(`#${widgetName}`).remove();
  }
}
